function calculateDiagonalLineRotation() {
    const swatchLabels = document.querySelectorAll('.swatch-input__label');

    swatchLabels.forEach(swatchLabel => {
        const width = swatchLabel.offsetWidth;
        const height = swatchLabel.offsetHeight;

        if (width > 0 && height > 0) {
            const diagonalLength = Math.sqrt(width ** 2 + height ** 2);

            const angleRad = Math.atan(height / width);
            const angleDeg = angleRad * (180 / Math.PI);

            const swatch = swatchLabel.querySelector('.swatch');
            if (swatch) {
                swatch.style.setProperty('--box--diagonal--size', `${diagonalLength}px`);
                swatch.style.setProperty('--swatch-rotation', `${angleDeg}deg`);
            }
        }
    });
}

window.addEventListener('DOMContentLoaded', calculateDiagonalLineRotation);
window.addEventListener('resize', calculateDiagonalLineRotation);
